import { Add, HelpOutline, Remove } from "@mui/icons-material";
import { Card, CardContent, Typography, Collapse, Button } from "@mui/material";
import { useState, useContext } from "react";
import { AppContext } from "../context/AppContext";
export default function DisclaimerCard() {
	const { appState } = useContext(AppContext);
	const { footerDisclaimer } = appState;

	const [expanded, setExpanded] = useState(false);

	const handleExpandClick = () => {
		setExpanded(!expanded);
	};
	return (
		<Card className="fullwidth-container" sx={{ p: 0, m: 0 }}>
			<CardContent>
				<Button
					onClick={handleExpandClick}
					variant="text"
					fullWidth
					startIcon={<HelpOutline sx={{ color: appState.colorPallete["scheme3"] }} />}
					endIcon={
						expanded ? (
							<Remove sx={{ color: appState.colorPallete["scheme3"] }} />
						) : (
							<Add sx={{ color: appState.colorPallete["scheme3"] }} />
						)
					}
				>
					<Typography variant="subtitle2" width={"100%"} color="textPrimary" sx={{ textAlign: "left" }}>
						Disclaimer
					</Typography>
				</Button>
				<Collapse
					in={expanded}
					timeout="auto"
					unmountOnExit
					onClick={handleExpandClick}
					sx={{ cursor: "pointer", textAlign: "left" }}
				>
					<CardContent>
						<Typography>{footerDisclaimer}</Typography>
					</CardContent>
				</Collapse>
			</CardContent>
		</Card>
	);
}
